<div v-if="menu.items" @click="toggle" aria-haspopup="true" aria-controls="overlay_tmenu">
    <table >
        <tr>
            <td >
                <font-awesome-icon 
                v-if="Array.isArray(menu.icon) && menu.icon.length === 2 && menu.icon.every(i => typeof i === 'string' && i.trim() !== '')" 
                    :icon="menu.icon" 
                />
            </td> 
            <td  v-if="menu.badge">
                <p-badge class="ml-auto" :value="menu.badge" />
            </td>
        </tr>
        <tr>
            <td>
                <span class="ml-2">{{ menu.label }} </span>
            </td>
            <td><i class="ml-auto border-1 surface-border border-round surface-100 text-xs p-1 pi pi-angle-up"></i></td>
        </tr>
    </table>

    <p-tiered-menu ref="menu" id="overlay_tmenu" :model="menu.items" popup>
        <template #item="{ item, props, hasSubmenu , root}">
            <router-link :to="item.to || ''" v-ripple class="flex align-items-center" v-bind="props.action">
                <font-awesome-icon 
                    v-if="Array.isArray(item.icon) && item.icon.length === 2 && item.icon.every(i => typeof i === 'string' && i.trim() !== '')" 
                    :icon="item.icon" 
                />
                <span class="ml-2">{{ item.label }}</span>
                <p-badge v-if="item.badge" class="ml-auto" :value="item.badge" />
                <span v-if="item.shortcut" class="ml-auto border-1 surface-border border-round surface-100 text-xs p-1">{{ item.shortcut }}</span>
                <i v-if="hasSubmenu" :class="['pi pi-angle-down text-primary', { 'pi-angle-down ml-2': root, 'pi-angle-right ml-auto': !root }]"></i>
            </router-link>
        </template>
    </p-tiered-menu>
</div>

<router-link v-else :to="menu.to || ''" v-ripple class="flex align-items-center mr-3 text-center"  >
    <table >
        <tr>
            <td >
                <font-awesome-icon :icon="menu.icon" /> 
            </td> 
            <td  v-if="menu.badge">
                <p-badge class="ml-auto" :value="menu.badge" />
            </td>
        </tr>
        <tr>
            <td>
                <span class="ml-2">{{ menu.label }}</span>
            </td>
        </tr>
    </table>
</router-link>